<template>
	<div style="height: 100%">
		<button id="closeMobileMenuBtn" class="btn-reset" aria-label="Close Mobile Menu" @click="$emit('close')">
			<span class="icon icon-remove" aria-hidden="true"></span>
		</button>
		<nav id="mobileMenu" role="primary">
			<div>
				<mobile-menu-header
					:current-menu="currentMenu"
					:header-text="headerText"
					:customer="headerData.customer"
					:logged-in="headerData.loggedIn"
					:local-store="headerData.localStoreJson"
					@go-back="goBack"
				/>
				<ul v-if="currentMenu && currentMenu.children && currentMenu.children.length > 0">
					<mobile-menu-item
						v-for="menuItem in currentMenu.children"
						:key="menuItem.id"
						:menu-item="menuItem"
						item-class="primary"
						@click.native="expand(menuItem)"
					/>
				</ul>
				<ul v-else-if="currentMenu">
					<mobile-menu-item
						v-for="menuItem in currentMenu"
						:menu-item="menuItem"
						:key="menuItem.id"
						item-class="primary"
						@click.native="expand(menuItem)"
					/>
				</ul>
				<ul v-else-if="!currentMenu">
					<mobile-menu-item
						v-for="menuItem in mainLinks"
						:menu-item="menuItem"
						:key="menuItem.id"
						@click.native="expand(menuItem)"
					/>
				</ul>
			</div>
		</nav>
	</div>
</template>

<script>
import clickOutside from '../../../directives/click-outside';
import MobileMenuHeader from './MobileMenuHeader.vue';
import MobileMenuItem from './MobileMenuItem.vue';
import { setMenuOpenClasses, unsetOpenClasses } from '../../util/menu.utils';

export default {
	name: 'MobileMenu',
	props: {
		headerData: {
			type: Object,
			required: true
		}
	},
	components: {
		MobileMenuHeader,
		MobileMenuItem
	},
	directives: {
		clickOutside
	},
	computed: {
		headerText() {
			if (this.currentMenu) return this.currentMenu.name;
			return this.headerData.localStoreJson ? 'Your Store' : null;
		},
		animalRxMenu() {
			return this.headerData.deptMenu.find(d => d.id === "13");
		},
		deptMenu() {
			return this.headerData.deptMenu.filter(d => d.id !== "13");
		},
		mainLinks() {
			const loggedIn = this.headerData.loggedIn;
			const pts = this.headerData.customer ? this.headerData.customer.rewardsTotalPoints : 0;
			return [
				{ id: 12, name: 'Shop Departments', calloutText: 'Departments', action: 'deptMenu', icon: 'cart', class: 'primary' },
				{ id: 20, name: 'Automotive Service Center', icon: 'automotive-service', class: 'primary', children: [
					{ parentID: 20, name: 'Tires', url: '/tires/' },
					{ parentID: 20, name: 'Batteries', url: '/batteries/' },
					{ parentID: 20, name: 'Services & Repair', url: '/automotive-service-repair/' },
				]
				},
				{ id: 21, name: 'Blain\'s Animal Rx', class: 'primary', action: 'animalRx', icon: 'animal-rx' },
				{ id: 13, name: 'My Account', url: '/account/', class: 'primary', icon: 'user' },
				{ id: 14, name: 'Blain\'s Rewards', url: '/account/rewards/', action: 'rewards', secondaryText: loggedIn ? `${pts} pts` : null, class: 'primary', icon: 'blain-eagle' },
				{ id: 15, name: 'Current Ad', url: '/sales-flyer/', class: 'primary', icon: 'current-ad' },
				{ id: 16, name: 'Blain\'s Blog', url: '/blog/', class: 'primary', icon: 'blainblog' },
				{ id: 17, name: 'Registries & Lists', url: '/gift-registry/', class: 'primary', icon: 'reglists' },
				{ id: 18, name: 'Store Finder', url: '/store-finder/', class: 'primary',  icon: 'eagle-pin' },
				{ id: 19, name: 'Today’s Deals', url: '/todays-deals/', class: 'primary', icon: 'best-price' },
				{ id: 6, name: 'Gift Cards', url: '/gift-cards/' },
				{ id: 7, name: 'Gift Guide', url: '/gifts/' },
				{ id: 8, name: 'Services', children: [
					{ parentID: 8, name: 'Drive-Thru Pickup', url: '/store-pickup/' },
					//{ parentID: 8, name: 'Drive-Thru Service', url: '/drivethru/' },
					{ parentID: 8, name: 'Credit Card', url: '/mastercard/' },
					{ parentID: 8, name: 'Extended Service Program', url: '/best-program/' },
					{ parentID: 8, name: 'Fishing & Hunting Licenses', url: '/fishing-hunting-licenses/' },
					{ parentID: 8, name: 'Gift Registries', url: '/gift-registry/' },
					{ parentID: 8, name: 'Other Services', url: '/other-services/' },
				] },
				{ id: 9, name: 'Customer Care', children: [
					{ parentID: 9, name: 'Contact Farm & Fleet', url: '/customer-care/' },
					{ parentID: 9, name: 'SDS Request Form', url: '/sds-request/' },
					{ parentID: 9, name: 'Shipping & Returns', url: '/shipping-returns/' },
					{ parentID: 9, name: 'Product Recalls', url: '/recalls/' },
					{ parentID: 9, name: 'Rebates', url: '/rebates/' },
					{ parentID: 9, name: 'SMS Text Messaging Help', url: '/sms/' },
					{ parentID: 9, name: 'FAQ', url: '/faq/' },
				] },
				{ id: 10, name: 'Our Company', children: [
					{ parentID: 10, name: 'About Us', url: '/about-us/' },
					{ parentID: 10, name: 'News', url: '/blog/category/events-news/' },
					{ parentID: 10, name: 'Careers', url: 'https://careers.farmandfleet.com/' },
					{ parentID: 10, name: 'Modeling', url: '/modeling/' },
					{ parentID: 10, name: 'Real Estate', url: 'https://realestate.farmandfleet.com' },
					{ parentID: 10, name: 'History', url: '/history/' },
					{ parentID: 10, name: 'Community', url: '/community/' },
					{ parentID: 10, name: 'Our Theme Song', url: '/theme-song/' },
					{ parentID: 10, name: 'Legal Notice', url: '/legal-notice/' },
					{ parentID: 10, name: 'Privacy Policy', url: '/privacy-policy/' },
					{ parentID: 10, name: 'Coupons', url: '/coupons/' },
					{ parentID: 10, name: 'Coupon Policy', url: '/coupon-acceptance-policy/' }
				] }
			];
		}
	},
	data() {
		return {
			currentMenu: null,
			menuHistory: [],
		};
	},
	methods: {
		goBack() {
			this.currentMenu = this.menuHistory[this.menuHistory.length - 1];
			this.menuHistory.pop();
		},
		expand(menuItem) {
			if (this.handleAction(menuItem.action)) {
				return;
			}

			if ((!menuItem.children || menuItem.children.length < 1) && menuItem.url) {
				window.location.replace(menuItem.url);
			} else {
				this.menuHistory.push(this.currentMenu);
				this.currentMenu = menuItem;
			}
		},
		handleAction(action) {
			if (action === 'deptMenu') {
				this.menuHistory.push(this.currentMenu);
				this.currentMenu = this.deptMenu;
				return true;
			}

			if (action === 'rewards') {
				this.loggedIn ? window.location.replace('/account/rewards/')
					: window.location.replace('/rewards/');
				return true;
			}

			if (action === 'animalRx') {
				this.menuHistory.push(this.currentMenu);
				this.currentMenu = this.animalRxMenu;
				return true;
			}

			return false;
		}
	},
	mounted() {
		setMenuOpenClasses(true);
	},
	destroyed() {
		unsetOpenClasses();
	}
};
</script>

<style lang='less'>
@import '~@less/_mixins.less';
#mobileMenu {
	background-color: #e5e7f1;
	position: fixed;
	height: 100%;
	bottom: 0;
	top: 0;
	left: 0;
	overflow-x: hidden;
	overflow-y: auto;
	box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14);
	width: 275px;
	z-index: 12;
	ul {
		overflow-x: hidden;
	}
}

#closeMobileMenuBtn {
	background-color: @LB;
	border: solid 2px #4aa6df;
	border-radius: 50%;
	color: #FFF;
	font-size: 16px;
	padding: 4px 5px 3px;
	position: fixed;
	left: 283px;
	top: 10px;
	z-index: 13;
}
</style>